import { instance } from '@/api/instances'

const getDalyaRecommendation = async (store, { personId, payload }) => {
  try {
    const recommendation = await instance.post(
      `persons/${personId}/dalya/recommendation`,
      {
        json: payload
      }
    )

    return [false, recommendation]
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'dalyaRecommendation/getDalyaRecommendation'
      },
      { root: true }
    )

    return [true, null]
  }
}

export default {
  getDalyaRecommendation
}
